<template>    
    <footer class="bgDarkTexture" >
        <!--RRSS-->
        <div class="container-fluid border-top border-primary d-flex flex-md-row justify-content-center">
            <h5 class="text-uppercase mb-0 pt-4">{{ $t('forum_follow_idc_footer') }}</h5>
        </div>

        <div class="container-fluid d-flex flex-md-row justify-content-center pb-4"> 
            <div class="rrssIcons d-flex flex-row align-items-center justify-content-center flex-sm-nowrap flex-wrap mx-lg-5 px-lg-5 px-3">
                <a class="fa-stack m-lg-4 m-2" href="https://www.facebook.com/IDCgames"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'facebook' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://twitter.com/IDCgames"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'twitter' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://www.instagram.com/idcgames/"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'instagram' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://www.pinterest.com/IDCgames/"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'pinterest-p' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://www.youtube.com/user/IDCgames"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'youtube' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://www.twitch.tv/idcgames"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'twitch' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://vk.com/id367009144"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'vk' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://www.tiktok.com/@idcgames"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'tiktok' }"/>
                </a>
                <a class="fa-stack m-lg-4 m-2" href="https://discord.gg/Nztb8hSvjF"  target="_blank">
                    <i class="far fa-circle fa-stack-2x primaryColor"></i>
                    <font-awesome-icon class="fa-stack-1x primaryColor" :icon="{ prefix: 'fab', iconName: 'discord' }"/>
                </a>			
            </div>	
        </div>

        <!-- >> footer-default top bar>> -->
        <div class="container-fluid border-top border-bottom border-green-lighter py-4"> 
            <div class="d-flex flex-lg-row flex-column py-4"> 
                <div class="col-lg-2 d-none d-sm-block my-auto footer-logo-container pr-0"> 
                    <a  rel="noopener noreferer" :href="`https://${$store.state.meta.lang}.idcgames.com`" class="big-logo-idc-footer">
                        <img class="logo-pegi footer-logo" src="https://cdn.idcgames.net/img/default/logo-idc-light.png" title="IDC/Games" alt="IDC/Games" height="92px">
                    </a>
                </div>

                <!-- <div class="col-lg-8 pl-0">  -->
                <div class="col-lg-10 pl-0"> 
                    <div class="row">
                        <div class="col-lg-12 d-flex flex-md-row flex-column justify-content-left mb-2 px-0">
                            <a class="border-white-lighter py-2 px-4 text-center d-block my-auto mr-4 text-uppercase" href="https://about.idcgames.com/about/" target="_blank">{{ $t('forum_about_idc_text') }}</a>	
                            <a class="border-white-lighter py-2 px-4 text-center d-block my-auto mr-4 text-uppercase" href="https://about.idcgames.com/about/docs/What-is-IDC-Games/" target="_blank">{{ $t('forum_idc_services_text') }}</a>	
                            <a class="border-white-lighter py-2 px-4 text-center d-block my-auto mr-4 text-uppercase" href="https://about.idcgames.com/about/docs/Publishing-Tools/" target="_blank">{{ $t('forum_idc_games_tools_text') }}</a>	
                            <a class="border-white-lighter py-2 px-4 text-center d-block my-auto mr-4 text-uppercase" href="https://about.idcgames.com/about/docs/IDC-Influencer2/" target="_blank">{{ $t('forum_idc_influencer_about_text') }}</a>	
                            <a class="border-white-lighter py-2 px-4 text-center d-block my-auto mr-4 text-uppercase" href="https://developer.idcgames.com/gameintegration/" target="_blank">{{ $t('forum_developer_corner_text') }}</a>
                        </div>
                        <div class="col-lg-12 col-12 d-flex flex-md-row flex-column justify-content-center pl-0">                            
                            <a class="btn btn-outline-primary px-4 text-center d-block distribute-games-btn bg-white text-dark" href="https://about.idcgames.com/about/docs/Distribute-Your-Game" target="_blank">{{ $t('forum_distribute_your_game_text') }}</a>	
                            <div class="d-flex m-auto a-tag-contents">                                
                                <a class="no-border-lighter p-2 text-center d-block my-auto text-uppercase pl-0 ml-0 mr-2" :href="`https://en.idcgames.com/doc/terms-of-use`" target="_blank">{{ $t('forum_privacy_legal_title_txt') }}</a>
                                <span class="d-none d-sm-block py-2 my-auto">|</span>

                                <a class="no-border-lighter p-2 text-center d-block my-auto text-uppercase mx-2" :href="`https://en.idcgames.com/doc/privacy-policy-and-cookies`" target="_blank">{{ $t('forum_privacy_policy_footer') }}</a>
                                <span class="d-none d-sm-block py-2 my-auto">|</span>

                                <a class="no-border-lighter p-2 text-center d-block my-auto text-uppercase ml-3 mr-4" :href="`https://en.idcgames.com/doc/privacy-policy-and-cookies`" target="_blank">{{ $t('forum_cookies_footer') }}</a>
                                <span class="d-none d-sm-block py-2 my-auto">|</span>

                                <a class="no-border-lighter p-2 text-center d-block my-auto text-uppercase pr-0 ml-2" :href="`https://en.idcgames.com/doc/return-policy`" target="_blank">{{ $t('forum_return_policy_title') }}</a>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>                    				
                </div>

                <!-- <div class="col-lg-2"></div> -->
            </div>
        </div>
        <!-- << end of top bar -->	
        
        <!--Copyright-->
        <div class="d-flex flex-row justify-content-center bg-dark p-2"> 
            <p class="m-auto py-2">{{ $t('forum_rights_reserved') }}</p> 
        </div> 
        <!--Cookies-->
        <div v-if="!$cookies.get('terms')" class="position-relative d-flex justify-content-center align-items-center closeCookiesBox">
            <div class="cookies position-absolute bg-secondary px-2"> 
                <div class="d-row col-12">
                    <button type="button" class="closeCookies close pt-3" aria-label="Close" v-on:click="termClose()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="d-row col-12 w-98">
                    <p class="avisolegal text-center py-3">{{ $t('forum_cookies_footer_text') }}<br>
                        <a :href="`https://${$store.state.meta.lang}.idcgames.com/doc/privacy-policy-and-cookies`" target="_blank" class="text-primary">{{ $t('forum_cookies_title_txt') }}</a> 
                    </p> 
                </div>
            </div>    
        </div>
    </footer> 
</template>
<script>
export default {
    data(){
        return {
            seen : true
        }
    },
    methods: {  
        termClose(truth){
            this.$cookies.set("terms", true, "2h")
            document.getElementsByClassName('closeCookiesBox')[0].style.visibility = 'hidden';
        }      
    }
}
</script>

<style lang="scss">
    @import '../assets/scss/variables.scss';
    .footer{
        background-color: #000000;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        a{
            color: $color__green--primary;
        }
    }
    @media (max-width: 870px) {
        .footer{
            display: block;
            text-align: center;
        }
    }
</style>
<style>
footer { bottom: 0; overflow: hidden;}
footer button.close, footer { z-index: 666; }
.closeCookies{ cursor: pointer}
.w-98{ width: 98%!important;}
.avisolegal{ font-size: 11pt;}
.border-white-lighter {
    border: 1px solid white;
    font-size: 12pt;
    width: 230px;
    height: 42px;
}
.border-white-lighter span{ font-size: 12pt;}
.bgDarkTexture a{
    font-weight: 100!important;    
}
.bgDarkTexture a:hover{
    color: #66ffb2 !important;
}
a.border-white-lighter:hover{
    border: 1px solid #66ffb2;    
}
.no-border-lighter{
    font-size: 13pt;
}
.bgDarkTexture a:visited{
    color: white;
}

a.distribute-games-btn:hover{
    background-color: #00ff7f!important;
    /* border-color: #00ff7f!important; */
}
.footer-logo-container {
   padding-left: 55px!important;
}
/* ###################### */

.distribute-games-btn{
	width: 365px;
	background-color: white;
    color: black!important;
    border-color: black!important;
    font-size: 16pt!important;
    line-height: 35px!important;
}

@media (max-width: 1550px) and (min-width: 1370px)  {
	.border-white-lighter{
		font-size: 10pt;
		height: auto;
	}	
	.no-border-lighter{
		font-size: 10pt;
	}
	.distribute-games-btn{
		font-size: 14pt;
		height: auto;
	}
	.footer-logo{
		height: 85px;
	}	
}

@media (max-width: 1370px) {
	.border-white-lighter, .mostplayed-border{
		font-size: 9pt;
		height: auto;
	} 
	.no-border-lighter{
		font-size: 9pt;
	}
	.distribute-games-btn{
		font-size: 13pt;
		height: auto;
	}
	.footer-logo{
		height: 85px;
	}	
}
@media (max-width: 768px){
	.border-white-lighter, .mostplayed-border{
	    font-size: 9pt;
	    height: auto;
	    margin: auto;
	    margin-bottom: 20px!important;
	}
	.distribute-games-btn{
		width: 100%;
		margin-left: 15px;
	}
	.no-border-lighter{
		width: 50%;
	}
	.a-tag-contents{
		margin-left: 15px!important;
	}
}
:root{
    --font-family-sans-serif: Jura!important;
    --font-family-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace!important;
}
</style>